__turbopack_context__.v({
  "logo": "uyVP1q_logo",
});
